import {
	CUSTOMER_PROFILING_SEGMENTATION_SUMMARY,
	TRANSACTIONAL_CROSS_SELLING,
} from "constants/paths"
import {
	CROSS_SELLING_SUBMODULE,
	CUSTOMER_BEHAVIOR_CUSTOMER_PROFILING_SUBMODULE,
} from "constants/features"
import customerProfilingImage from "assets/images/illustration_customer.png"

export const banners = [
	{
		bannerId: CUSTOMER_BEHAVIOR_CUSTOMER_PROFILING_SUBMODULE,
		title: "phronesis.promotion-banner.customer-profiling.title",
		description: "phronesis.promotion-banner.customer-profiling.description",
		image: customerProfilingImage,
		buttonText: "phronesis.promotion-banner.customer-profiling.button",
		url: CUSTOMER_PROFILING_SEGMENTATION_SUMMARY,
	},
	{
		bannerId: CROSS_SELLING_SUBMODULE,
		title: "phronesis.promotion-banner.cross-selling.title",
		description: "phronesis.promotion-banner.cross-selling.description",
		image: customerProfilingImage,
		buttonText: "phronesis.promotion-banner.cross-selling.button",
		url: TRANSACTIONAL_CROSS_SELLING,
	},
]
